class Options {
  useSkills: boolean = true;
  winningRank: number = 0;
  winnerCount: number = 1; // 우승자 수 (1~20)
}

const options = new Options();
export default options;
